export default __webpack_public_path__ + "89acf71eafbe1ed3bb1bea244176a766.svg";